import { useState, useEffect } from 'react';
import deletionStatusService from '../services/deletionStatusService';

/**
 * Хук для отримання статусу видалення акаунту
 * Автоматично підписується на зміни і управляє станом
 */
export const useDeletionStatus = () => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;

    // Підписуємося на зміни статусу
    const unsubscribe = deletionStatusService.subscribe((newStatus) => {
      if (mounted) {
        setStatus(newStatus);
        setLoading(false);
        setError(null);
      }
    });

    // Отримуємо поточний статус
    deletionStatusService.getStatus()
      .then(currentStatus => {
        if (mounted) {
          setStatus(currentStatus);
          setLoading(false);
        }
      })
      .catch(err => {
        if (mounted) {
          setError(err);
          setLoading(false);
        }
      });

    return () => {
      mounted = false;
      unsubscribe();
    };
  }, []);

  // Функція для примусового оновлення
  const refresh = async () => {
    setLoading(true);
    try {
      const newStatus = await deletionStatusService.getStatus(true);
      setStatus(newStatus);
      setError(null);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return {
    status,
    loading,
    error,
    refresh,
    hasDeletionRequest: status?.deletionRequested || false
  };
};

export default useDeletionStatus;